import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

const formatDuration = (ms) => {
  if (ms == null || ms < 0) return '';
  const totalSecs = Math.floor(ms / 1000);
  const h = Math.floor(totalSecs / 3600);
  const m = Math.floor((totalSecs % 3600) / 60);
  const s = totalSecs % 60;
  if (h > 0) return `${h}h ${m}m ${s}s`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
};

export const RunList = ({ jobId }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      if (!jobId) return;
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('jobId', jobId));
    },
    [jobId],
  );

  const augFieldDefs = useCallback((fieldToFieldDef) => {
    fieldToFieldDef.elapsed = {
      field: 'elapsed',
      displayName: 'Elapsed Time',
      precedence: 101,
      sortable: false,
      filter: false,
      cellClass: 'ag-right-aligned-cell',
      valueGetter: ({ data: run }) => {
        if (!run?.startInstant) return null;
        const end = run.endInstant ? new Date(run.endInstant) : new Date();
        return end - new Date(run.startInstant);
      },
      valueFormatter: ({ value }) => formatDuration(value),
    };
  }, []);

  return <EntityList entity="RUN" augRowsReq={augRowsReq} augFieldDefs={augFieldDefs} />;
};
